import {ColumnSpec} from '@xh/hoist/cmp/grid';
import {div, img, span} from '@xh/hoist/cmp/layout';
import bloombergLogo from '../tabs/markets/widgets/news/images/bloomberg.png';
import cnbcLogo from '../tabs/markets/widgets/news/images/cnbc.png';
import msnbcLogo from '../tabs/markets/widgets/news/images/msnbc.png';
import reutersLogo from '../tabs/markets/widgets/news/images/reuters.png';
import yahooLogo from '../tabs/markets/widgets/news/images/yahoo.png';
import './news.scss';

const SOURCE_LOGOS: Record<string, {src: string; alt: string}> = {
    B: {src: bloombergLogo, alt: 'Bloomberg'},
    R: {src: reutersLogo, alt: 'Reuters'},
    C: {src: cnbcLogo, alt: 'CNBC'},
    Y: {src: yahooLogo, alt: 'Yahoo Finance'},
    M: {src: msnbcLogo, alt: 'MSNBC'}
};

export const sourceCol: ColumnSpec = {
    field: 'source',
    width: 36,
    align: 'center',
    renderer: value => {
        const logo = SOURCE_LOGOS[value];
        if (!logo) return value;
        return img({src: logo.src, alt: logo.alt, title: logo.alt, width: 20, height: 20});
    }
};

export const tokenizedHeadlineCol: ColumnSpec = {
    field: {name: 'tokenizedHeadline'},
    flex: 1,
    renderer: tokens => {
        return div({
            items: tokens.map(t => span({item: t.text, className: `news_headline_${t.type}`})),
            className: 'news_headline'
        });
    }
};
